import React from "react";
import Modal from "./Modal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleXmark, faExclamationTriangle } from "@fortawesome/free-solid-svg-icons";
import SecondaryButton from "./SecondaryButton";
import PrimaryButton from "./PrimaryButton";

const ConfirmDeleteModal = ({ isOpen, onClose, onConfirm, itemName }) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} zIndex={35} size="max-w-2xl">
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-xl font-semibold text-gray-900">Confirmação de Exclusão</h2>
        <button
          onClick={onClose}
          aria-label="Fechar modal"
          className="text-gray-400 hover:text-gray-600 transition-colors"
        >
          <FontAwesomeIcon icon={faCircleXmark} className="text-3xl" />
        </button>
      </div>

      <div className="flex items-center space-x-4 mb-6">
        <div className="flex items-center justify-center w-12 h-12 rounded-full bg-red-100 text-red-600">
          <FontAwesomeIcon icon={faExclamationTriangle} className="text-2xl" />
        </div>
        <p className="text-gray-800 text-lg">
          Você tem certeza que deseja excluir <span className="font-semibold">{itemName}</span>?
        </p>
      </div>

      <div className="flex justify-end space-x-3">
        <SecondaryButton
          onClick={onClose}
          className="px-5 py-2 rounded-md text-gray-700 bg-gray-200 hover:bg-gray-300 focus:ring-2 focus:ring-gray-400"
        >
          Cancelar
        </SecondaryButton>
        <PrimaryButton
          onClick={onConfirm}
          className="px-6 py-2 rounded-md bg-red-600 hover:bg-red-700 focus:ring-2 focus:ring-red-500"
        >
          Confirmar
        </PrimaryButton>
      </div>
    </Modal>
  );
};

export default ConfirmDeleteModal;
